import React from 'react';
export function OpenQuestionBadge() {
  return <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-sm border border-[#F9C88C] bg-sf-amber-light px-1.5 text-[11px] font-semibold leading-[18px] text-sf-amber-text" data-id="element-869" data-mp="3fr8sz5ygvcwf">
      <div className="h-3 w-3" aria-hidden="true" data-id="element-870" data-mp="x0msnmn7zpvk" />
      Open question
    </span>;
}